import { UtilsProvider } from "../../common/providers/utils-provider.service";
import { OrganizationRole } from "../../common/models/organization-role";
import { User } from "../../common/models/user";
import { Exercice } from "../../common/models/exercice";
import { Library } from "../../common/models/library";
import { FeedbackItemRightsList } from "../../feedback/providers/feedback-rights";

export class ExerciceRights {
    public Ready: Promise<boolean> = new Promise((resolve, reject) => resolve(false));
    private _itemRightsList: ExerciceItemRightsList | null = null;
    private _screenRightsList: ExerciceScreenRightList | null = null;
    private _paramsItem: ExerciceItemRightsParams | null = null;
    private _paramsScreen: ExerciceScreenRightsParams | null = null;
    private _bestOfItemRight = 10000;
    private _bestOfScreenRight = 10000;
    constructor(private _utils: UtilsProvider) {
        this.setDefault();
    }

    //
    //
    // PUBLIC
    //
    //

    public evaluateItemRight(params: ExerciceItemRightsParams): void {

        /**
         * Les paramètres reçus contiennent le exercice, le user.id
         * et le organizationId. Les droits évalués doivent répondrent
         * à la question : qu'est-ce que je (user.id) peux faire avec
         * cet exercice (exercice.id) dans cette organisation (organizationId)
         * avec mon rôle (this._bestOfItemRight).
         */

        this._paramsItem = params;
        this.setDefault();
        this.setBestOfRole();

        const exercice = this._paramsItem.exercice;
        const libraries = this._utils.findManyIn([exercice.libraryId], this._paramsItem.libraries, 'id');
        const orgIds = this._utils.getKeyValues(libraries, 'ownerOrganizationId');

        if(!this._itemRightsList) return;
        switch (this._bestOfItemRight) {
        case OrganizationRole.ID_ADMIN:
            // this._paramsItem.user est un admin
            // tous les exercices
            this._itemRightsList.view = true;
            this._itemRightsList.edit = true;
            this._itemRightsList.delete = true;
            this._itemRightsList.duplicate = true;
            break;

        case OrganizationRole.ID_SUPERCOACH:
            // this._paramsItem.user est un supercoach
            // tous les exercices de son organisation et tous les exercices de l'organisation 1 (public)
            if (orgIds.indexOf(this._paramsItem.organizationId) > -1 || orgIds.indexOf(1) > -1) {
                this._itemRightsList.view = true;
                this._itemRightsList.edit = true;
                this._itemRightsList.delete = true;
                this._itemRightsList.duplicate = true;
            }
            break;

        case OrganizationRole.ID_COACH:
            // this._paramsItem.user est un coach
            // lister et dupliquer tous les exercices de son orgnisation et tous les exercices de l'organisation 1 (public)
            // modifier tous les exercices qu'il a créé
            if (orgIds.indexOf(this._paramsItem.organizationId) > -1 || orgIds.indexOf(1) > -1) {
                this._itemRightsList.view = true;
                this._itemRightsList.duplicate = true;
            }
            this._itemRightsList.edit = (exercice.createrId === this._paramsItem.user.id);
            this._itemRightsList.delete = (exercice.createrId === this._paramsItem.user.id);
            if (this._itemRightsList.duplicate === false) {
                // s'assurer qu'il peut dupliquer ses exercices
                this._itemRightsList.duplicate = (exercice.createrId === this._paramsItem.user.id);
            }
            break;

        case OrganizationRole.ID_ATHLETE:
            // this._paramsItem.user est un athlète
            // tous les exercices de son organisation et tous les exercices de l'organisation 1 (public)
            if (orgIds.indexOf(this._paramsItem.organizationId) > -1 || orgIds.indexOf(1) > -1) {
                this._itemRightsList.view = true;
            }
            break;

        case OrganizationRole.ID_GUEST:
            // this._paramsItem.user est un invité
            // tous les exercices de son organisation et tous les exercices de l'organisation 1 (public)
            if (orgIds.indexOf(this._paramsItem.organizationId) > -1 || orgIds.indexOf(1) > -1) {
                this._itemRightsList.view = true;
            }
            break;

        default:
            // rien
        }
    }

    public evaluateScreenRights(params: ExerciceScreenRightsParams): void {

        /**
         * Détermine les droits que l'utilisateur possède
         * pour les commandes générales des écrans.
         */

        this._paramsScreen = params;
        this.setDefault();
        this.setBestOfRole();

        if(!this._screenRightsList) return;
        switch (this._bestOfScreenRight) {
        case OrganizationRole.ID_ADMIN:
            // this._paramsItem.user est un admin
            this._screenRightsList.list = true;
            this._screenRightsList.add = true;
            this._screenRightsList.edit = true;
            this._screenRightsList.delete = true;
            break;

        case OrganizationRole.ID_SUPERCOACH:
            // this._paramsItem.user est un super-coach
            this._screenRightsList.list = true;
            this._screenRightsList.add = true;
            this._screenRightsList.edit = true;
            this._screenRightsList.delete = true;
            break;

        case OrganizationRole.ID_COACH:
            // this._paramsItem.user est un coach
            this._screenRightsList.list = true;
            this._screenRightsList.add = true;
            this._screenRightsList.edit = true;
            this._screenRightsList.delete = true;
            break;

        case OrganizationRole.ID_ATHLETE:
            // this._paramsItem.user est un athlète
            this._screenRightsList.list = true;
            this._screenRightsList.add = false;
            this._screenRightsList.edit = false;
            this._screenRightsList.delete = false;
            break;

        case OrganizationRole.ID_GUEST:
            // this._paramsItem.user est un invité
            this._screenRightsList.list = false;
            this._screenRightsList.add = false;
            this._screenRightsList.edit = false;
            this._screenRightsList.delete = false;
            break;

        default:
            // rien
        }
    }

    public getItemRightsList(): ExerciceItemRightsList {
      if(!this._itemRightsList) throw new Error('Item rights list is not defined');
        return this._itemRightsList;
    }

    public getScreenRightsList(): ExerciceScreenRightList {
      if (!this._screenRightsList) throw new Error('Screen rights list is not defined');
        return this._screenRightsList;
    }

    public getItemParams(): ExerciceItemRightsParams {
      if (!this._paramsItem) throw new Error('Item params is not defined');
        return this._paramsItem;
    }

    public getScreenParams(): ExerciceScreenRightsParams {
      if (!this._paramsScreen) throw new Error('Screen params is not defined');
        return this._paramsScreen;
    }

    public get LIST() {
        if (this._screenRightsList) {
            return this._screenRightsList.list;
        }
        return false;
    }

    public get ADD() {
        if (this._screenRightsList) {
            return this._screenRightsList.add;
        }
        return false;
    }

    public get EDIT() {
        if (this._screenRightsList) {
            return this._screenRightsList.edit;
        }
        return false;
    }

    public get DELETE() {
        if (this._screenRightsList) {
            return this._screenRightsList.delete;
        }
        return false;
    }

    private setDefault(): void {

        const defaultItemRights: ExerciceItemRightsList = {
            view: false,
            edit: false,
            delete: false,
            duplicate: false,
        };
        this._itemRightsList = defaultItemRights;

        const defaultScreenRights: ExerciceScreenRightList = {
            list: false,
            add: false,
            edit: false,
            delete: false,
        };
        this._screenRightsList = defaultScreenRights;

        this._bestOfItemRight = 10000;
        this._bestOfScreenRight = 10000;
    }

    private setBestOfRole() {

        if (this._paramsItem && this._paramsItem.rolesIds.length > -1) {
            for (let i = 0; i < this._paramsItem.rolesIds.length; i++) {
                if (this._paramsItem.rolesIds[i] < this._bestOfItemRight) {
                    this._bestOfItemRight = this._paramsItem.rolesIds[i];
                }
            }
        }

        if (this._paramsScreen && this._paramsScreen.rolesIds.length > -1) {
            for (let i = 0; i < this._paramsScreen.rolesIds.length; i++) {
                if (this._paramsScreen.rolesIds[i] < this._bestOfScreenRight) {
                    this._bestOfScreenRight = this._paramsScreen.rolesIds[i];
                }
            }
        }
    }
}

export interface ExerciceItemRightsList {
    view: boolean;
    edit: boolean;
    delete: boolean;
    duplicate: boolean;
}

const defaultRights: ExerciceItemRightsList = {
  view: false,
  edit: false,
  delete: false,
  duplicate: false,
}

export function mapExerciceItemRightsToExerciceRights(exerciceRights: string[]): ExerciceItemRightsList {
  const rights = { ...defaultRights };

  exerciceRights.forEach((right) => {
    if (right in rights) {
      rights[right as keyof ExerciceItemRightsList] = true;
    }
  });

  return rights;
}


export interface ExerciceScreenRightList {
    list: boolean;
    add: boolean;
    edit: boolean;
    delete: boolean;
}

export interface ExerciceItemRightsParams {
    user: User;
    organizationId: number;
    exercice: Exercice;
    rolesIds: number[];
    libraries: Library[];
}

export interface ExerciceScreenRightsParams {
    rolesIds: number[];
}
